import { render, staticRenderFns } from "./TopStakeholders.vue?vue&type=template&id=06384b67&scoped=true&"
import script from "./TopStakeholders.vue?vue&type=script&lang=js&"
export * from "./TopStakeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06384b67",
  null
  
)

export default component.exports